/**
 * Created by rathompson on 4/13/22
 * File: AppNames
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { createContext } from 'react'
import { APP_ID_TO_NAME } from '../constants/LabelConstants'
import { DONT_RENDER_APP } from '../constants/GlobalConstants'

const AppContext = createContext({
  apps: {},
  getAppName: (app_id, defValue) => APP_ID_TO_NAME[app_id],
  dontRenderApp: (app_id) => DONT_RENDER_APP.includes(app_id)
})

export default AppContext
